<header>
  <nav class="navbar navbar-expand-md navbar-f4i fixed-top" [ngClass]="{'inverse': inverse}">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <a class="navbar-brand header-logo" [routerLink]="'/'" title="{{ 'To the home page' | translate }}"
        data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
        <img class="logo" [src]="inverse ? 'assets/images/logo-blue.png' : 'assets/images/logo-white.png'"
          alt="{{ siteName }}" title="{{ siteName }}">
      </a>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="d-flex flex-column gap-3 pt-3 pt-md-0 flex-md-row align-items-md-center w-100">
          <ul class="navbar-nav ms-0 me-0 mx-md-auto gap-1 gap-md-2">
            <!--
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page"
                [routerLink]="'/'">{{ 'Home' | translate }}</a>
              </li>  -->
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/services'">
                {{ 'Services' | translate }}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/learning'">
                {{ 'Learning' | translate }}
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/fundingopportunities'">
                {{ 'Funding Opportunities' | translate }}
              </a>
            </li>
            <!--
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                  routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/recruitment'">{{
                'Recruitment' | translate }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                  routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/jobs'">{{ 'Jobs'
                | translate }}</a>
              </li> -->
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/blog'">
                {{ 'Blog' | translate }}
              </a>
            </li>
            <li class="nav-item">
              <div class="dropdown">
                <a class="nav-link purple dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                  routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="'/summit2026'">
                  {{ 'Funds4impact Summit' | translate }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="summitDropdown">
                  <li>
                    <a class="dropdown-item" [routerLink]="'/summit2024'" data-bs-toggle="collapse"
                      data-bs-target=".navbar-collapse.show">
                      {{ 'Funds4impact Summit 2024' | translate }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" [routerLink]="'/summit2025'" data-bs-toggle="collapse"
                      data-bs-target=".navbar-collapse.show">
                      {{ 'Funds4impact Summit 2025' | translate }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" [routerLink]="'/summit2026'" data-bs-toggle="collapse"
                      data-bs-target=".navbar-collapse.show">
                      {{ 'Funds4impact Summit 2026' | translate }}
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <!--
            <a *ngIf="!(isAuthenticated$ | async)" type="button" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show" [ngClass]="inverse ? 'btn-f4i-link-blue' : 'btn-f4i-link-white'" [routerLink]="'/login'">{{
            "Member portal" | translate }}</a>  -->
          <app-language-selector replace-host></app-language-selector>
          @if ((isAuthenticated$ | async)) {
          <div class="dropdown">
            @if ((myProfile$ | async); as myProfile) {
            <a class="d-flex align-items-center link-dark text-decoration-none dropdown-toggle"
              [ngClass]="inverse ? 'btn-f4i-link-blue' : 'btn-f4i-link-white'" id="loggedInDropdown" type="button"
              data-bs-toggle="dropdown" title="{{ 'Account menu' | translate }}">
              <img [imageData]="myProfile?.photo+';'+uploadTypeEnum.profile+';true'"
                onerror="this.onerror=null; this.src='assets/images/header/avatar.png'"
                class="img-thumbnail rounded-circle me-1" src="assets/images/header/avatar.png" alt="avatar">
            </a>
            <ul class="dropdown-menu dropdown-menu-start dropdown-menu-md-end" aria-labelledby="loggedInDropdown">
              <li>
                <span class="dropdown-item-text">
                  {{ 'Hi' | translate }}, {{ myProfile.firstName }} {{ myProfile.lastName }}
                </span>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                @if (myProfile?.settings?.showAdmin) {
                <a class="dropdown-item" [routerLink]="'/admin'">
                  {{ 'Admin' | translate }}
                </a>
                }
              </li>
              @if (myProfile?.settings?.showAdmin) {
              <li>
                <a class="dropdown-item" [routerLink]="'/user/dashboard'">{{ 'Dashboard' | translate }}</a>
              </li>
              }
              @if (myProfile?.settings?.showAdmin) {
              <li>
                <a class="dropdown-item" [routerLink]="'/user/account'">{{ 'Account' | translate }}</a>
              </li>
              }
              @if (myProfile?.settings?.showAdmin) {
              <li>
                <a class="dropdown-item" [routerLink]="'/user/profile'">{{ 'Profile' | translate }}</a>
              </li>
              }
              @if (myProfile?.settings?.showAdmin) {
              <li>
                <hr class="dropdown-divider">
              </li>
              }
              <li>
                <a class="dropdown-item" [routerLink]="'/user/webinars'">
                  {{ 'Events' | translate }}
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="logOff()" (keydown.enter)="logOff()" tabindex="0">
                  {{ 'Log off' | translate }}
                </a>
              </li>
            </ul>
            }
          </div>
          }
          <!--
            <app-notifications replace-host *ngIf="(isAuthenticated$ | async)" [inverse]="inverse"></app-notifications>
          -->
          @if ((isAuthenticated$ | async) === false) {
          <button class="btn btn-f4i-white ms-2" id="logInButton" type="button" (click)="login()">
            <i class="fas fa-solid fa-user me-2"></i>
            {{ 'Log in' | translate }}
          </button>
          }
        </div>
      </div>
      <!-- <form class="form-inline my-2 my-lg-0" (ngSubmit)="onSubmit(mainSearchForm.value)" [formGroup]="mainSearchForm"
        novalidate autocomplete="off">
        <div class="input-group search">
          <div class="form-outline">
            <input type="search" id="mainSearch" class="form-control" formControlName="searchPhrase"
              placeholder="{{ 'Search' | translate }}" />
            </div>
            <button type="submit" class="btn btn-blue" title="{{ 'Search' | translate }}">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </form> -->
    </div>
  </nav>
</header>
